export type Make = 'MONO' | 'MASTER' | 'KRAFT_PRINT' | 'BUFFER';

export interface BoxType {
  key: string;
  make: Make | null;
  label: string;
  short: string;
  tick: string[];
  off: string[];
  note: string;
}

const PRINT = ['Printing', 'UV Dripoff', 'Aqueous Coating', 'Lamination'];

export const BOX_TYPES: BoxType[] = [
  {
    key: 'printed', make: null, label: 'Printed box', short: 'Printed',
    tick: ['Printing', 'Corrugation', 'Die Cutting', 'Folder Gluer'], off: [],
    note: '',
  },
  {
    key: 'mono', make: 'MONO', label: 'Mono carton', short: 'Mono',
    tick: ['Printing', 'Die Cutting', 'Folder Gluer'], off: ['Corrugation', 'Flute Pasting'],
    note: 'No corrugation',
  },
  {
    key: 'master', make: 'MASTER', label: 'Master box', short: 'Master',
    tick: ['Corrugation', 'Die Cutting', 'Folder Gluer'], off: PRINT,
    note: 'No printing',
  },
  {
    key: 'kraft', make: 'KRAFT_PRINT', label: 'Kraft printing', short: 'Kraft print',
    tick: ['Printing', 'Corrugation', 'Die Cutting', 'Folder Gluer'], off: [],
    note: 'Layer 1 is printed kraft',
  },
  {
    key: 'buffer', make: 'BUFFER', label: 'Buffer', short: 'Buffer',
    tick: ['Corrugation', 'Die Cutting', 'Folder Gluer'], off: PRINT,
    note: 'No printing',
  },
];

export const boxType = (key: string | null) => BOX_TYPES.find((t) => t.key === key) ?? null;

export const typeOfMake = (make: string | null | undefined) =>
  BOX_TYPES.find((t) => t.make === (make ?? null)) ?? BOX_TYPES[0]!;

export const makeLabel = (make: string | null | undefined) => (make ? typeOfMake(make).label : '');
